import {DeserializedRecord, deserializeItem, Deserializer} from "../../Helpers";

interface Count extends DeserializedRecord {
  count: number;
  measurementCount: number;
  surveyCount: number;
  adherenceCount: number;
}

const deserializeTriggerEventCount: Deserializer<Count> = (data) => deserializeItem(data);

export {
  deserializeTriggerEventCount,
  Count as TriggerEventCount
};
